import { FC } from "react";
import i18next from "i18next";
import { goToPopup } from "../../../../libs/services";
import { POPUP_SETTING } from "../../../../constants/routes";
import { PopupContainer, ToolbarDialog } from "../../../shared/popups";
import { useGetUser, useTimer } from "../../../../libs/hooks";
import { getStorage } from "../../../../libs/storage";
import { STORAGE_USER_ID } from "../../../../constants/localstorage";
import { IconButton, TextField } from "@material-ui/core";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { deleteAccount } from "../../../../libs/auth";
import * as yup from "yup";

const schema = yup.object().shape({
  token: yup.string().required(i18next.t("destruction.enter_code")),
});
const PopupDeleteAccountComponent: FC = () => {
  const currentUserPhone = useGetUser(getStorage(STORAGE_USER_ID))?.phone;
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({ resolver: yupResolver(schema) });
  const { minutes, seconds, countDown } = useTimer(1);
  const onSubmit = (value: any) => deleteAccount(value.token);
  return (
    <ToolbarDialog
      title={i18next.t("destruction.destruction")}
      backFunc={() => goToPopup(POPUP_SETTING)}
      menuItem={() => (
        <IconButton className="text-white" type="submit" form="destruction_form">
          <i className="icon-ok" />
        </IconButton>
      )}
    >
      <div className="d-flex justify-content-center flex-column text-center px-2">
        <p dir="rtl">{i18next.t("destruction.description")}</p>
        <span>{currentUserPhone}</span>
        <form onSubmit={handleSubmit(onSubmit)} id="destruction_form" className="px-2">
          <TextField
            helperText={<span style={{ color: "#ff0000" }}>{errors.token?.message}</span>}
            name="token"
            inputRef={register}
            inputProps={{ maxLength: 10 }}
            className=" w-100"
            label={i18next.t("destruction.destruction_code")}
          />
        </form>
        {seconds !== 0 && (
          <span dir="auto" className="mt-5">
            {i18next.t("global.please_wait")} {countDown}
          </span>
        )}
      </div>
    </ToolbarDialog>
  );
};

export default PopupDeleteAccountComponent;
